import { useEffect } from "react";
import { ApiUserMinimal } from "src/api/types";
import Avatar from "src/components/Avatar";
import UserAvatars from "src/components/UserAvatars";
import Select, { SelectValue } from "src/components/field/fields/Select";
import { WrapperProps } from "src/components/field/utils/Wrapper";
import useUsers from "src/hooks/api/services/users/useUsers";

interface UsersProps {
	isClearable?: boolean;
	wrapper?: WrapperProps;
	value?: SelectValue;
	onChange: (value?: number) => void;
}

const Users = ({ isClearable, wrapper, value, onChange }: UsersProps) => {
	const { users, status, actions } = useUsers();

	useEffect(() => {
		if (status === "idle" && !users.length) {
			actions.list();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Select
			{...{ wrapper, isClearable }}
			value={value ? value : undefined}
			onChange={(value) => onChange(value ? value : undefined)}
			options={users.map((user) => ({
				value: user.id.toString(),
				label: <SelectItem variant="list" {...{ user }} />,
			}))}
			theme={{
				item: {
					indicator: true,
				},
				value: {
					renderValue: () => (
						<div className="flex items-center flex-wrap">
							{value && Array.isArray(value) ? (
								<>
									{value.length > 1 ? (
										<UserAvatars
											avatar={{
												size: "xsmall",
											}}
											users={users.filter((u) =>
												value?.includes(u.id.toString())
											)}
										/>
									) : (
										<SelectItem
											variant="row"
											user={users.find((u) =>
												value?.includes(u.id.toString())
											)}
										/>
									)}
								</>
							) : (
								<SelectItem
									variant="row"
									user={users.find(
										(u: any) =>
											value === u.id.toString() ||
											value === u.id
									)}
								/>
							)}
						</div>
					),
				},
			}}
		/>
	);
};

interface SelectItemProps {
	user?: ApiUserMinimal;
	variant: "list" | "row";
}

const SelectItem = ({ user, variant }: SelectItemProps) => {
	if (!user) return <></>;
	return (
		<div
			className={`flex items-center gap-2 ${
				variant === "list" && "mr-2"
			}`}
		>
			<Avatar src={user.avatar} size="xsmall" />
			<span className="font-regular">{user.first_name}</span>
		</div>
	);
};

export default Users;
